<template>
  <div>
    <div class="loan_form">
      <b-card no-body>
        <b-tabs pills card>
          <b-tab title="First Loan" active>
            <b-card-text>
              <div class="estimator_desc d-flex justify-content-between">
                <p class="first_val">First Amount</p>
                <p class="val_money">₱ {{value}}</p>
              </div>
              <vue-slider ref="slider" v-model="value" v-bind="options"></vue-slider>
              <p class="disclaimer">
                <img src="@/assets/images/icons/lock.svg" alt />
                All your data is under secure protection!
              </p>
              <p class="returns">
                You will have to return:
                <span>₱{{value}}</span>
              </p>
              <b-button class="estimator_apply">Apply Now</b-button>
              <p class="disclaimer text-center">
                Loan amount 10 000 PHP borrowed and fully repaid. The interest rate of 0% per day.
                Total amount payable = 10 000 PHP
              </p>
            </b-card-text>
          </b-tab>
          <b-tab title="Repeat Loan">
            <b-card-text>
              <h4 class="text-center mt-4">Identify yourself by entering your phone and password.</h4>
              <b-button class="estimator_signin">Sign In</b-button>
              <p
                class="disclaimer text-center"
              >Loan amount 5 000 PHP borrowed and fully repaid after 90 days of using the loan. Interest rate 2.18% per day. Total amount payable = 14 810 PHP</p>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

export default {
  components: {
    VueSlider
  },
  name: "estimator",
  data() {
    return {
      value: 10000,
      options: {
        dotSize: 25,
        width: "auto",
        height: 5,
        contained: false,
        direction: "ltr",
        data: null,
        min: 1000,
        max: 10000,
        interval: 500,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: "active",
        tooltipPlacement: "top",
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0
      }
    };
  }
};
</script>

<style lang="scss">
.loan_form {
  padding: 20px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 2.5px 4.33px 21.84px 2.16px rgba(0, 0, 0, 0.38);
  width: 100%;
  height: 500px;
  position: relative;
  .card {
    border: 0;
    background: transparent;
    z-index: 1;
  }
  .estimator_desc {
    color: $base-text-color;
    font-size: 16px;
    font-weight: 700;
  }
  .vue-slider-process {
    background-color: $base-color-blue;
  }
  .vue-slider-dot-handle {
    border: 4px solid $base-color-blue;
  }
  .card-header {
    padding: 0;
    border: 0;
    margin-bottom: 10px;
    ul {
      margin: 0;
      li {
        width: 50%;
        border: 0;
        background-color: $base-bg-lightred;
        padding: 2px;
        a {
          height: 45px;
          text-align: center;
          line-height: 30px;
          text-transform: uppercase;
          font-size: 16px;
          font-weight: 700;
          color: #434343;
          white-space: nowrap;
        }
        a:focus {
          outline: none;
        }
        a.active {
          background-color: $base-color-red;
        }
      }
      li:first-child {
        border-radius: 4px 0 0 4px;
      }
      li:last-child {
        border-radius: 0 4px 4px 0;
      }
    }
  }
  .disclaimer {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 14px;
    margin-top: 30px;
    img {
      width: 16px;
      margin-right: 10px;
    }
  }
  .returns {
    color: #666;
    margin-top: 65px;
    span {
      color: #434343;
      font-weight: 700;
    }
  }
  .estimator_apply {
    width: 100%;
    margin-top: 10px;
    height: 60px;
    background-color: $base-color-red;
    text-transform: uppercase;
    border: 0;
    font-weight: 700;
  }
  .estimator_signin {
    width: 100%;
    margin-top: 125px;
    height: 60px;
    background-color: $base-color-red;
    text-transform: uppercase;
    border: 0;
    font-weight: 700;
  }
}
.loan_form::after {
  content: "";
  background: #f4f4f4;
  width: 100%;
  height: 235px;
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 0 0 8px 8px;
}
@media (max-width: 992px) {
  .loan_form {
    height: auto;
    margin-top: 20px;
  }
  .loan_form::after {
    content: unset;
  }
}
</style>